/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AuthMeResponse } from './AuthMeResponse';

export type AuthMeResponseApiRespoonse = {
    data?: AuthMeResponse;
    status?: AuthMeResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace AuthMeResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

